import { MultiSelect } from 'primeng/multiselect';

/**
 * Realigns the MultiSelect overlay position after data changes
 * @param multiSelect - The MultiSelect component instance
 */
export function realignMultiSelectOverlay(multiSelect: MultiSelect | undefined | null): void {
    if (!multiSelect) {
        return;
    }

    setTimeout(() => {
        if (multiSelect.overlayVisible) {
            const overlayChild = (multiSelect as any).overlayViewChild;
            if (overlayChild && overlayChild.alignOverlay) {
                overlayChild.alignOverlay();
            }
        }
    }, 0);
}